import api from "./Api";

class PdvAtualizacaoService {
  GetConfiguracao() {
    return api.get("/v1/PdvAtualizacao/Configuracao").then((response) => {
      return response.data;
    });
  }

  PostRelease(payload) {
    return api.post("/v1/PdvAtualizacao/Release", payload).then((response) => {
      return response.data;
    });
  }

  PutRelease(payload) {
    return api.put("/v1/PdvAtualizacao/Release", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRelease(payload) {
    return api
      .delete("/v1/PdvAtualizacao/Release/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PublicarRelease(payload) {
    return api
      .post("/v1/PdvAtualizacao/Release/Publicar/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  UploadInstalador(payload) {
    return api
      .post("/v1/PdvAtualizacao/Release/UploadInstalador", payload)
      .then((response) => {
        return response.data;
      });
  }

  PostArquivo(payload) {
    return api.post("/v1/PdvAtualizacao/Arquivo", payload).then((response) => {
      return response.data;
    });
  }

  PutArquivo(payload) {
    return api.put("/v1/PdvAtualizacao/Arquivo", payload).then((response) => {
      return response.data;
    });
  }

  DeleteArquivo(payload) {
    return api
      .delete("/v1/PdvAtualizacao/Arquivo/" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PdvAtualizacaoService();
